import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-group-wrapper',
  template: `
    <div class="form-group">
      <ng-container #fieldComponent />
    </div>
  `,
  styles: [
    `
      .form-group {
        width: fit-content;
        min-width: 240px;
        margin-bottom: 16px;
      }
    `,
  ],
  standalone: true,
})
export class FormGroupFormlyWrapperComponent extends FieldWrapper {}
